"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.directionsCreateForTrip = exports.directionsCreateForTripInitial = exports.directionsRead = exports.directionsCreate = void 0;
const Directions_1 = require("../models/Directions");
const firestoreSerialize_1 = __importDefault(require("../models/firebase/firestoreSerialize"));
const DirectionsController_1 = __importDefault(require("./google-maps/DirectionsController"));
const Trip_1 = require("./Trip");
// CRUD functions
async function directionsCreate(directions, firestore) {
    const data = (0, firestoreSerialize_1.default)(directions);
    return firestore.create('directions', data);
}
exports.directionsCreate = directionsCreate;
async function directionsRead(id, firestore) {
    const { value } = await firestore.read('directions', id);
    return (0, Directions_1.directionsDeserialize)(value, firestore);
}
exports.directionsRead = directionsRead;
// other functions
async function directionsCreateForTripInitial(trip, options, firestore, database) {
    // don't do for single-location trips
    var _a;
    if (((_a = trip.locations) === null || _a === void 0 ? void 0 : _a.length) === 1) {
        console.log('Ignoring; single-location trip');
        return;
    }
    // read GMS directions
    const gmsDirections = await DirectionsController_1.default.readForTrip(trip, undefined, options);
    const directions = (0, Directions_1.directionsFromGoogleMapsDirectionsResponse)(gmsDirections, trip.id, firestore);
    // create Wave directions
    const { id } = await directionsCreate(directions, firestore);
    // update trip
    await (0, Trip_1.tripUpdate)(trip.customerId, trip.id, {
        directions: id,
        estimatedMiles: directions.legs.reduce((total, leg) => total + leg.distanceM, 0) * 0.00062,
        estimatedMinutes: directions.legs.reduce((total, leg) => total + leg.durationS, 0) / 60,
    }, database);
}
exports.directionsCreateForTripInitial = directionsCreateForTripInitial;
async function directionsCreateForTrip(trip, driverCoordinates, options, firestore, database) {
    // read GMS directions
    const gmsDirections = await DirectionsController_1.default.readForTrip(trip, driverCoordinates, options);
    const directions = (0, Directions_1.directionsFromGoogleMapsDirectionsResponse)(gmsDirections, trip.id, firestore);
    // create Wave directions
    const { id } = await directionsCreate(directions, firestore);
    // update trip
    await (0, Trip_1.tripUpdate)(trip.customerId, trip.id, {
        directions: id,
    }, database);
}
exports.directionsCreateForTrip = directionsCreateForTrip;
